export default __webpack_public_path__ + "static/media/file.ad6d2317.svg";